module.exports = __webpack_public_path__ + "static/logo_white-6024e3b83edb20d1aaaee061615f8dd2.png";